import React, { useState, useEffect } from "react";
import { useGetApiQuery } from "../../../redux/services/apiHome";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import PdfZipItem from "../../../components/PdfZipItem";
import { convertStringToArray } from "../../../Utils/utils";

const getDocumentUrl = (path) => {
  if (!path) return null;
  try {
    const url = new URL(path, `${process.env.REACT_APP_PUBLIC_URL}/`);
    return ["http:", "https:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
};

const ComplianceReportsTab = ({ onLastUpdatedChange }) => {
  const [openSection, setOpenSection] = useState(null);
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    currentData: complianceOfficerData = [],
    isFetching,
    isError,
  } = useGetApiQuery({
    url: "apInformation_reports",
    lang: languageType,
  });

  console.log({ complianceOfficerData });

  useEffect(() => {
    const date = complianceOfficerData?.[0]?.changed;
    onLastUpdatedChange?.(date || null);
  }, [complianceOfficerData, onLastUpdatedChange]);

  if (isFetching) return <Loader />;
  if (isError || !Array.isArray(complianceOfficerData)) {
    return <p role="alert">Unable to load reports. Please try again later.</p>;
  }

  return (
    <div className="container">
      <div className="title-sec">
        <h2>Information, reports, compliance reports filed by NEEPCO</h2>
      </div>

      {complianceOfficerData.length === 0 && <p>No reports available.</p>}
      {complianceOfficerData.map((section, sectionIndex) => {
        const sectionId = `${languageType}-${section?.title}-${sectionIndex}`;
        const documents = convertStringToArray(section?.field_document_equity);
        return (
          <details
            key={sectionId}
            className="border rounded mb-3 compliance-reports-section"
            open={openSection === sectionId}
          >
            <summary
              onClick={(event) => {
                event.preventDefault();
                setOpenSection((current) =>
                  current === sectionId ? null : sectionId,
                );
              }}
              className="p-3 bg-light compliance-reports-summary"
            >
              <span className="d-inline-flex align-items-center gap-2">
                <span>{section?.counter}.</span>
                <span>{section?.title}</span>
              </span>
            </summary>
            <div className="p-3">
              <div className="table-responsive">
                <table className="table table-striped custom-table mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Title</th>
                      <th scope="col">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.length === 0 && (
                      <tr>
                        <td colSpan={3}>No documents available.</td>
                      </tr>
                    )}
                    {documents.map((item, index) => {
                      const documentUrl = getDocumentUrl(item.file_path);
                      return (
                        <tr key={`${item.file_path}-${index}`}>
                          <td data-key="S.No.">{index + 1}</td>
                          <td data-key="title">
                            {item.title || section?.title}
                          </td>
                          <td data-key="View">
                            {documentUrl ? (
                              <PdfZipItem
                                filePath={documentUrl}
                                filesize={item.file_size}
                              />
                            ) : (
                              <span className="text-muted">Not available</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </details>
        );
      })}
    </div>
  );
};

export default ComplianceReportsTab;
